// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugOutlinedSvg from "@ant-design/icons-svg/es/asn/BugOutlined";
import AntdIcon from '../components/AntdIcon';

var BugOutlined = function BugOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BugOutlinedSvg
  }));
};

BugOutlined.displayName = 'BugOutlined';
export default React.forwardRef(BugOutlined);